/* eslint-disable import/prefer-default-export */
export const dataReturn = (resp, data) => {
  switch (resp.status) {
    case 200:
      return data;
    case 400:
      throw new Error(data.message);
    case 401:
      throw new Error(data.message);
    case 404:
      throw new Error(data.message);
    case 422:
      throw new Error(data.message);
    case 500:
      throw new Error(data.message);
    default:
      throw new Error(resp.statusText);
  }
};
